<template>
     <div class="modules">
        <div class="fund-container">
            <div class="summary">
                <h1 class="title"> {{ $t("lang.QRCodeInvitations") }}</h1>
            </div>
            <div class="m-module">
                <div class="section">
                    <div class="mod">
                        <div class="bd">
                            <img class="qrcode" :src="qrcodeUrl" />
                        </div>
                        <div class="ft">
                            <div class="qr-text">{{ $t("lang.registerNumber") }} {{ userInfo.inviteCount  }}</div>
                        </div>
                        <div class="ft">
                            <div class="qr-text">{{ $t("lang.ScanTheQRCode") }}</div>
                        </div>
                    </div>
                    <div class="mod">
                        <div class="hd">
                            <h3 class="title">{{ $t("lang.invitations") }}</h3>
                            <!-- <div class="copy"></div> -->
                        </div>
                        <div class="bd" style="padding:6px 0;">
                            <van-field  v-model="value" rows="3" type="textarea"  />
                        </div>
                        <div class="ft">
                            <van-button  @click="handleCopy(value)" class="btn-copy" color="#f2f2f2" size="large">{{ $t("lang.invitedUsers") }}</van-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    <script>
    import QRCode  from "qrcode";
    import Header from "@/components/mobile/header";
    import {BASE_GLOB_API} from "@/config.js";
    import {axiosGet,axiosPost} from '@/api/api';
    import { Toast } from 'vant';
    export default {
        name:'invite-m',
        components: {
            Header,
        },
        data(){
            return {
                api:BASE_GLOB_API,
                url:{
                    info:BASE_GLOB_API+'/user/info',
                },
                qrcodeUrl:'',
                lang: "",
                value:'',
                userInfo:{}
            }
        },
        mounted(){
           
        },
        created(){
          this.lang = sessionStorage.getItem("Language")
          this.platform()
        },
        methods:{
            handleCopy(content){
                this.$copyText(content).then(res=>{
                    Toast.success(this.$t("lang.replicationSuccessful"))
                },
                err => {
                    Toast.fail(this.$t("lang.replicationFailed"))
                })
            },
            platform(){
                axiosGet(this.url.info).then(res=>{
                   if(res.code ==200){
                       this.userInfo =res.result
                       this.value =window.location.protocol +'//'+ window.location.hostname +':'+ window.location.port +'/#/signup?inviteCode='+res.result.inviteCode
                       console.log("value",this.value)
                       let self = this;
                        QRCode.toDataURL(
                            this.value,
                        { errorCorrectrionLevel: "H", version: 8 },
                        function (err, url) {
                            if (!err) {
                            self.qrcodeUrl = url;
                            }
                        }
                    );
                   }else{
                        this.$message.error(res.message);
                    }
                })
               
            }, 
        }
    }
    </script>
    <style lang="less" scoped>
    .fund-container {
        .summary {
            background:#f4f5f6; border-radius:4px; padding:30px; display:flex; justify-content: space-between; align-items: center; margin-bottom:30px;
        }
        .m-module {
            .section {
                padding-top:20px;
                .mod {
                    margin-bottom:24px;
                    .hd {
                        display:flex; justify-content: space-between; align-items: center; margin-bottom:5px; padding:0 16px;
                        .title {
                            font-weight:normal; font-size:14px;
                        }
                        .copy {
                            width:16px; height:16px; 
                            // background:url(~@/assets/img/copy.svg) no-repeat center center/contain;
                        }
                    }
                    .bd {
                        background:#fff; padding:16px;
                        // box-shadow:0 3px 4px rgba(0,0,0,.08);
                         text-align: center;
                        .qrcode {
                            width:180px; height:180px; margin:0 auto;
                        }
                    } 
                    .ft {
                        box-shadow:0 3px 4px rgba(0,0,0,.08);
                        .qr-text {
                            background:#f2f2f2; text-align:center; padding:15px; 
                        }
                    }
                }
            }
        }
        .btn-copy {
            .van-button__text {color:#333; font-size:14px;}
        }
      }
    </style>